export default "__VITE_ASSET__BdOCtgA4__"